/* mh.js — chỉ những mảnh JS thật sự cần. Không framework, không phụ thuộc ngoài. */
(function () {
  'use strict';

  /* 1. Menu mobile ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mh-nav-toggle]');
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav.hidden = open;
  });

  /* 2. Đổi biến thể trên PDP -------------------------------------------- */
  /* Mỗi form buy block mang sẵn JSON biến thể; đổi <select> thì tìm variant
     khớp rồi cập nhật input[name=id], giá và trạng thái nút. */
  document.querySelectorAll('[data-mh-variants]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-mh-variant-json]').textContent); }
    catch (err) { return; }

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-mh-option]'));
    var idInput = root.querySelector('input[name="id"]');
    var button = root.querySelector('[data-mh-atc]');
    var priceEl = root.querySelector('[data-mh-price]');
    var compareEl = root.querySelector('[data-mh-compare]');
    if (!selects.length || !idInput) return;

    function money(cents) {
      var fmt = root.getAttribute('data-mh-money') || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }

    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var match = data.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      if (!match) {
        button.disabled = true;
        button.textContent = button.getAttribute('data-mh-unavailable') || 'Unavailable';
        return;
      }

      idInput.value = match.id;
      button.disabled = !match.available;
      button.textContent = match.available
        ? (button.getAttribute('data-mh-label') || 'Add to cart')
        : (button.getAttribute('data-mh-soldout') || 'Sold out');

      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  /* 3. Ô số lượng trong giỏ tự submit ------------------------------------ */
  document.querySelectorAll('[data-mh-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* 4. Giỏ hàng trượt + thêm vào giỏ không rời trang --------------------- */
  var drawer = document.getElementById('mh-drw');
  if (drawer) {
    var moneyFmt = drawer.getAttribute('data-money-format') || '${{amount}}';
    var itemsEl = drawer.querySelector('[data-mh-drw-items]');
    var footEl = drawer.querySelector('[data-mh-drw-foot]');
    var totalEl = drawer.querySelector('[data-mh-drw-total]');
    var countEl = drawer.querySelector('[data-mh-drw-count]');
    var lastFocus = null;

    function fmtMoney(cents) {
      function num(v, dec, comma) {
        var s = (v / 100).toFixed(dec);
        var p = s.split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
        return p.length > 1 ? p[0] + (comma ? ',' : '.') + p[1] : p[0];
      }
      return moneyFmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        if (key === 'amount_no_decimals') return num(cents, 0, false);
        if (key === 'amount_with_comma_separator') return num(cents, 2, true);
        if (key === 'amount_no_decimals_with_comma_separator') return num(cents, 0, true);
        return num(cents, 2, false);
      });
    }

    function setCounts(n) {
      document.querySelectorAll('[data-mh-cart-count]').forEach(function (el) {
        el.textContent = '(' + n + ')';
      });
      if (countEl) countEl.textContent = '(' + n + ')';
    }

    function render(cart) {
      setCounts(cart.item_count);
      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="mh-drw__empty">Your cart is empty.</p>';
        footEl.hidden = true;
        return;
      }
      var html = '';
      cart.items.forEach(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_128x$1$2') : '';
        html += '<div class="mh-drw__it" data-line="' + (i + 1) + '">' +
          (img ? '<img src="' + img + '" alt="" width="64" height="64" loading="lazy">' : '<img alt="" width="64" height="64">') +
          '<div class="mh-drw__tx">' +
            '<a class="mh-drw__nm" href="' + it.url + '">' + it.product_title + '</a>' +
            (it.variant_title ? '<div class="mh-drw__vr">' + it.variant_title + '</div>' : '') +
            '<div class="mh-drw__qty">' +
              '<button type="button" data-mh-drw-minus aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-mh-drw-plus aria-label="Increase">+</button>' +
              '<button type="button" class="mh-drw__rm" data-mh-drw-remove>Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="mh-drw__pr">' + fmtMoney(it.final_line_price) + '</div>' +
        '</div>';
      });
      itemsEl.innerHTML = html;
      totalEl.textContent = fmtMoney(cart.total_price);
      footEl.hidden = false;
    }

    function refresh(open) {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
                   { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); if (open) show(); return cart; });
    }

    function show() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var btn = drawer.querySelector('.mh-drw__x');
      if (btn) btn.focus();
    }
    function hide() {
      drawer.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mh-drw-close]')) { hide(); return; }
      if (e.target.closest('[data-mh-drw-open]')) { e.preventDefault(); refresh(true); return; }

      var row = e.target.closest('.mh-drw__it');
      if (!row) return;
      var line = Number(row.getAttribute('data-line'));
      var qty = Number(row.querySelector('.mh-drw__qty span').textContent);
      var next = null;
      if (e.target.closest('[data-mh-drw-plus]')) next = qty + 1;
      else if (e.target.closest('[data-mh-drw-minus]')) next = Math.max(0, qty - 1);
      else if (e.target.closest('[data-mh-drw-remove]')) next = 0;
      if (next === null) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: next })
      }).then(function (r) { return r.json(); }).then(render);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) hide();
    });

    /* Chặn submit của MỌI form add-to-cart → gửi ngầm rồi mở giỏ trượt.
       Có lỗi thì thả cho form chạy kiểu thường, không làm khách kẹt. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"], [name="add"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'error'); });
          return r.json();
        })
        .then(function () { return refresh(true); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  }

  /* 5. Gợi ý khi gõ ô tìm kiếm ------------------------------------------- */
  document.querySelectorAll('[data-mh-search]').forEach(function (root) {
    var input = root.querySelector('input[name="q"]');
    var out = root.querySelector('[data-mh-search-out]');
    if (!input || !out) return;
    var timer = null;
    var controller = null;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { out.hidden = true; out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,article,page&resources[limit]=6';
        fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = d.resources.results;
            var rows = [].concat(res.products || [], res.articles || [], res.pages || []);
            if (!rows.length) { out.hidden = true; out.innerHTML = ''; return; }
            out.innerHTML = rows.map(function (r) {
              var img = r.featured_image && r.featured_image.url ? r.featured_image.url : '';
              return '<a class="mh-sg__it" href="' + r.url + '">' +
                (img ? '<img src="' + img + '" alt="" width="40" height="40" loading="lazy">' : '') +
                '<span>' + r.title + '</span></a>';
            }).join('');
            out.hidden = false;
          })
          .catch(function () { /* huỷ hoặc mất mạng — bỏ qua, ô tìm kiếm vẫn submit được */ });
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { out.hidden = true; }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { out.hidden = true; }
    });
  });
})();
